import Form from "react-bootstrap/Form";
import styled from "styled-components";
import { WidgetSettingFC } from "types/Setting";

interface TextInputInfo {
  label: string;
  placeholder?: string;
}

export const TextInputSetting: WidgetSettingFC<string, TextInputInfo> = ({
  data,
  setData,
  info: { label, placeholder },
}) => {
  return (
    <OuterContainer>
      <Form.Label>{label}</Form.Label>
      <Form.Control
        type="text"
        value={data || ""}
        placeholder={placeholder}
        onChange={(e) => setData(e.target.value)}
      />
    </OuterContainer>
  );
};

const OuterContainer = styled.div`
  margin-bottom: 35px;
`;
